<template>
  <div class="nx-signing-modal-method-p12">
    <h4>Please prepare your p12 certificate</h4>

    <h5 class="mt-4">
      The client program is going to ask for your certificate
    </h5>

    <p class="mt-4">
      <b-spinner />
    </p>
  </div>
</template>

<script>
import SignClient from "@nextore/nx-signing/src/api/sign-client.api";

export default {
  props: {
    value: {},
    isNonPdf: {
      type: Boolean,
      default: false
    },
    isDrawing: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    console.log('isDrawing', this.isDrawing)
    try {
      const signClient = new SignClient();

      await signClient.init();

      const { digest } = this.value;

      var dataFinal ={};
      if(!this.isDrawing)
      {
         const data = await signClient.p12SignDoc(digest.digest);
         dataFinal = data;
      }
      else
      {
         const data = await signClient.p12SignPdf(digest.digest);
         dataFinal = data;
      }
     

      this.$emit("input", {
        ...this.value,
        signature: dataFinal,
      });
      this.$emit("next");
    } catch (ex) {
      if (ex.response) {
        this.$emit("input", ex.response.data);
      } else if (
        ["CLIENT_NOT_INSTALLED", "CLIENT_NOT_STARTED"].includes(ex.message)
      ) {
        this.$emit("input", ex.message);
      }

      this.$emit("fail");

      throw ex;
    }
  },
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method-p12 {
  text-align: center;
}
</style>
